import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31d56ab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-description" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Contact your clinic to connect your account! ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" These clinics have invited you join them on Ava Connect! Accepting the invite will allow you to interact with this clinic via the Ava Connect platform. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" You may decline or revoke your invite acceptance at any time under Patient Settings > Manage Clinics. ")
const _hoisted_5 = { class: "buttons-row" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Accept ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Decline ")
const _hoisted_8 = { class: "buttons-row" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Accepted!")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("undo")
const _hoisted_11 = { class: "buttons-row" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Declined")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("undo")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Continue! ")

import BaseTypography from "@/ui-library/base-typography/base-typography.vue";
import BaseModal from "@/ui-library/base-modal/base-modal.vue";
import BaseListItem from "../../ui-library/base-list-item/base-list-item.vue";
import BaseButton from "../../ui-library/base-button/base-button.vue";
import { usePatientConnectClinicStore } from "./store/patient-connect-clinic-store";
import { ref } from "vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'patient-connect-clinics-popup',
  setup(__props) {

const patientConnectClinicStore = usePatientConnectClinicStore();

const acceptedInvitations = ref<number[]>([]);
const declinedInvitations = ref<number[]>([]);

const noClinicsToConnect = computed(() => pendingInvites.value.length === 0);

const pendingInvites = computed(
  () => patientConnectClinicStore.getPendingInvites
);

const title = computed(() =>
  noClinicsToConnect.value
    ? "There are no clinics to connect"
    : "You are invited"
);

const answeredInvites = computed(() => [
  ...acceptedInvitations.value,
  ...declinedInvitations.value,
]);

const areInvitesAnswered = computed(
  () =>
    pendingInvites.value.filter((i) => !answeredInvites.value.includes(i.id))
      .length === 0
);

const isRespondedTo = (inviteId: number) => {
  // invite Id is not included in acceptedInvitations or declinedInvitations
  return !answeredInvites.value.includes(inviteId);
};

const refreshPage = () => {
  window.location.reload();
};
const closeModal = () => {
  patientConnectClinicStore.closeInvitationModal();
};
const onContinue = () => {
  noClinicsToConnect.value ? closeModal() : refreshPage();
};

const respondToInvite = (inviteId: number, status: boolean) => {
  status
    ? acceptedInvitations.value.push(inviteId)
    : declinedInvitations.value.push(inviteId);
  patientConnectClinicStore.respondToInvitation(inviteId, status);
};

const undoAccept = (inviteId: number) => {
  acceptedInvitations.value = acceptedInvitations.value.filter(
    (i) => i !== inviteId
  );
  patientConnectClinicStore.resetInvitation(inviteId);
};
const undoDecline = (inviteId: number) => {
  declinedInvitations.value = declinedInvitations.value.filter(
    (i) => i !== inviteId
  );
  patientConnectClinicStore.resetInvitation(inviteId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    title: _unref(title),
    isOpen: _unref(patientConnectClinicStore).getIsInvitationModalOpen,
    class: "patient-connect-clinics-popup-container"
  }, {
    "footer-affirmative-button": _withCtx(() => [
      _createVNode(BaseButton, {
        disabled: !_unref(areInvitesAnswered),
        primary: "",
        onClick: onContinue
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(noClinicsToConnect))
          ? (_openBlock(), _createBlock(BaseTypography, {
              key: 0,
              body2: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(BaseTypography, { body2: "" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(BaseTypography, { caption: "" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ], 64))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pendingInvites), (invite) => {
        return (_openBlock(), _createBlock(BaseListItem, {
          key: invite.id,
          class: "invitation-row"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(invite.clinicName), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(BaseTypography, { caption: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(invite.clinicAddress), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createVNode(BaseButton, {
                class: "ava-grow",
                primary: "",
                onClick: ($event: any) => (respondToInvite(invite.id, true))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(BaseButton, {
                class: "ava-grow",
                caution: "",
                primary: "",
                onClick: ($event: any) => (respondToInvite(invite.id, false))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 512), [
              [_vShow, isRespondedTo(invite.id)]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _createVNode(BaseTypography, { body2: "" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(BaseButton, {
                tertiary: "",
                onClick: ($event: any) => (undoAccept(invite.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseTypography, { caption: "" }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 512), [
              [_vShow, acceptedInvitations.value.includes(invite.id)]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
              _createVNode(BaseTypography, null, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              _createVNode(BaseButton, {
                tertiary: "",
                onClick: ($event: any) => (undoDecline(invite.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseTypography, { caption: "" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 512), [
              [_vShow, declinedInvitations.value.includes(invite.id)]
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["title", "isOpen"]))
}
}

})